import axiosInstance from '../../environment/axiosInstance'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
toast.configure()

class ticketServices {
    fetchTickets = async () => {
        try {
            const response = await axiosInstance.get("/support/business_owner/ticket/channel/live chat?page=1");
            if (response.data.Data) {
                const data = response.data.Data;
                return { success: true, data: data };
            } else {
                return { success: false, message: response?.data?.message, data: null };
            }
        } catch (error: any) {
            toast.error(error.response.data.message, { position: toast.POSITION.TOP_RIGHT, autoClose: 1000 })
            return {
                success: false,
                message:
                    error.message === "Network Error"
                        ? "Network Error"
                        : error.response.data.message,
            };
        }
    }

}
const ticketservices = new ticketServices()
export default ticketservices;